import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    new Popover(element);
});

import * as checkboxCollapse from './scripts/collapse-checkbox';
checkboxCollapse.init();

import * as affix from "@elements/affix";
affix.init({}, {
    base:'.js-affix-checkout-bar',
    placeholder:'.js-affix-checkout-bar__placeholder',
    container: '.js-affix-checkout-bar__container'
});

import * as cashback from './scripts/cashback';
cashback.init();

import * as qrScanner from './scripts/qr-scanner';
qrScanner.init();

import * as payment from './scripts/payment';
payment.init();

import Modal from 'bootstrap/js/dist/modal';
onFind('[data-bs-toggle="modal"]',function (element) {
    new Modal(element);
});

import * as keycard from './scripts/keycard';
keycard.init();

import * as datePicker from '@elements/datepicker';
datePicker.init();

import * as dateInput from '@elements/date-input';
dateInput.init(
    {
        placeholderDate: false
    }
);

import * as personalizationForm from './scripts/personalization-form';
personalizationForm.init();

import * as requiredIfChecked from './scripts/required-if-checked';
requiredIfChecked.init();

import * as showOnClick from './scripts/show-on-click';
showOnClick.init();

import * as fileInput from './scripts/file-input';
fileInput.init();

import * as toggleDisabled from './scripts/toggle-disabled';
toggleDisabled.init();

import * as historyBack from './scripts/history-back';
historyBack.init();

import * as formTracking from './scripts/form-tracking';
formTracking.init();